'use strict';

/**
 * @ngdoc service
 * @name webAgro1App.LoadingService
 * @description
 * # LoadingService
 * Factory in the webAgro1App.
 */
angular.module('webAgro1App').factory('LoadingService', function() {
  var ELEMENT_LOADER = '#bg-loader';

  var existsClass = function(element, className) {
    return angular.element(element).hasClass(className);
  };

  var addClass = function(element, className) {
    if (!existsClass(ELEMENT_LOADER, className)) {
      angular.element(ELEMENT_LOADER).addClass(className);
    }
  };

  var removeClass = function(element, className) {
    if (existsClass(ELEMENT_LOADER, className)) {
      angular.element(ELEMENT_LOADER).removeClass(className);
    }
  };

  return {
    showLoading: function() {
      removeClass(ELEMENT_LOADER, 'hide');
    },

    hideLoading: function() {
      addClass(ELEMENT_LOADER, 'hide');
    }
  };
});
